import ReactDOM from 'react-dom'
import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {Provider} from 'react-redux'
import {store} from './redux/store'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
//import './_metronic/assets/css/style.rtl.css'
//import './_metronic/assets/sass/style.scss'
//import './_metronic/assets/sass/style.react.scss'

import {AppRoutes} from './app/routing/AppRoutes'
import {setupAxios} from './redux/setup-axios'
import 'react-notifications-component/dist/theme.css'
import {ReactNotifications} from 'react-notifications-component'
import {I18nProvider} from './_metronic/i18n/i18nProvider'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

Chart.register(...registerables)

/** After a dev rebuild, the tab may request old lazy chunk URLs → ChunkLoadError. Reload once to recover. */
const CHUNK_RELOAD_KEY = 'maarefati_chunk_reload'
function isChunkLoadReason(reason: unknown): boolean {
  if (!reason) return false
  const name = (reason as {name?: string}).name
  const message = String((reason as Error).message || reason)
  return name === 'ChunkLoadError' || message.includes('Loading chunk') || message.includes('ChunkLoadError')
}
function reloadOnceForStaleChunks(): void {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1') return
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
  window.location.reload()
}

if (typeof window !== 'undefined') {
  window.addEventListener(
    'load',
    () => {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY)
    },
    {once: true}
  )
  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadReason(event.reason)) return
    reloadOnceForStaleChunks()
  })
  window.addEventListener(
    'error',
    (event) => {
      const el = event.target as HTMLElement | null
      if (el?.tagName !== 'SCRIPT') return
      const src = (el as HTMLScriptElement).src || ''
      if (!src.includes('.chunk.js')) return
      reloadOnceForStaleChunks()
    },
    true
  )
}

const container = document.getElementById('root')!
const root = createRoot(container) // createRoot(container!) if you use TypeScript


root.render(
  <>
    <ReactNotifications />
    <MetronicI18nProvider>
      <I18nProvider>
        <Provider store={store}>
          <AppRoutes />
        </Provider>
      </I18nProvider>
    </MetronicI18nProvider>
  </>
)

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL ?? '/'}service-worker.js`.replace(/\/{2,}/g, '/'), {
          updateViaCache: 'none',
        })
        .catch((error) => {
          console.error('[ServiceWorker] registration failed:', error)
        })
    })
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister())
    })
  }
}